import React, { Component } from 'react';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './FeatureList.css';
import { Feature } from './Feature';

const Slider = require('react-slick');

class FeatureList extends Component {
  
  render() { 
    return (
      <div className="feature-list">
	      <Slider {...silderSettings}>
	      	{this.renderFeatures()}
	      </Slider>
      </div>
    );
  }

  renderFeatures() {
  	return Features.map((f,i) => {
  		return (
  			<div key={`feature_${i}`}>
  				<Feature {...f} />
  			</div>
  		);
  	});
  }

}

const silderSettings = {
      infinite: true,
      speed: 1000,
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      draggable: false,
      autoplay: true,
      autoplaySpeed: 5000
 };

const Features = [
	{
		title: 'SOCIAL WALL',
		question: 'How much time to you spend (waste) on social network?',
		summary: 'Gain insight into your weekly, monthly and yearly income and spending habits with the Cash Flow tool. View transactions by category, merchant or date across all of your financial accounts. Gain transparency into where your money goes each month, set spending goals and adjust as needed.',
		image: require('../../assets/images/screenshots/socialwall.png'),
		overlayColor: 'blue',
		backgroundImage: require('../../assets/images/screenshots/socialwall-background.jpg')
	},
	{
		title: 'DETAILED PROFILE',
		question: 'Would you like to replicate the success of your savvy friends or trusted investors?',
		summary: 'Gain insight into your weekly, monthly and yearly income and spending habits with the Cash Flow tool. View transactions by category, merchant or date across all of your financial accounts. Gain transparency into where your money goes each month, set spending goals and adjust as needed.',
		image: require('../../assets/images/screenshots/profile.png'),
		overlayColor: 'green',
		backgroundImage: require('../../assets/images/screenshots/profile-background.jpg')
	}
];

export { FeatureList };



/** WEBPACK FOOTER **
 ** ./src/common/FeatureList.js
 **/